import { call, select, delay } from 'redux-saga/effects'

import { isWaiting } from '../selectors'
import { addToQueue } from './addToQueue'

const WAITING_SECONDS = 20 // in seconds
const DELAY = 100 // in milliseconds

export function* addToQueueWithWaiting({ payload }) {
  let times = 0
  while (yield select(isWaiting)) {
    if (times > (1000 * WAITING_SECONDS) / DELAY) {
      return new Error(`Exit wait timeout. Waited ${WAITING_SECONDS} seconds`)
    }
    times++
    yield delay(DELAY)
  }
  return yield call(addToQueue, { payload })
}
